export const formatNumber = (number: number | string, lng: string): string => {
  return Intl.NumberFormat(lng, { maximumFractionDigits: 18 }).format(Number(number))
}
